"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'checkmark',
  label: 'Checkmark',
  applyToTypes: ['boolean'],
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row,
          isCsv = _ref.isCsv;
        if (isCsv) {
          return value ? 'Yes' : 'No';
        }
        return value ? /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null) : null;
      }
    };
  }
};